import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { AgentCompany, AgentCreateMemberModel, AgentCreateMemberPayload, AgentCreateMemberResponse, AgentUserFilterPayload } from "src/app/models/agent";
import { MemberSearchResult } from "src/app/models/member-lookup";

import { AgentService } from "src/app/services/agent.service";
import { HelperService } from "src/app/services/helper.service";
import { MaskService } from "src/app/services/mask.service";

@Component({
    selector: 'mwp-member-create',
    templateUrl: './create.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CounselorMemberCreateComponent implements OnInit {
    public companies: AgentCompany[];

    public selectedCompanyId: number;
    public agentCreateMemberModel: AgentCreateMemberModel;
    public displayForm: boolean;
    public memberSearchResult: MemberSearchResult;
    public displayConfirmForm: boolean;
    public apiUrl = ContentHeaderKey.CounselorCreateMember;

    constructor(
        private agentService: AgentService,
        private helperService: HelperService,
        private maskService: MaskService,
    ) {
    }

    ngOnInit() {
        this.agentService.getCompaniesForCreateMember().subscribe((response: AgentCompany[]) => {
            this.companies = response;
        });
    }

    public companyChange(event: MatOptionSelectionChange): void {
        if (event.isUserInput) {
            this.selectedCompanyId = event.source.value;
            const l_AgentUserFilterPayload = new AgentUserFilterPayload();
            l_AgentUserFilterPayload.companyID = this.selectedCompanyId;

            this.reset();

            this.agentService.getCreateMemberModelByCompany(l_AgentUserFilterPayload).subscribe((response: AgentCreateMemberModel) => {
                this.agentCreateMemberModel = response;
                this.displayForm = true;
            });
        }
    }

    private reset(): void {
        this.displayForm = false;
        this.displayConfirmForm = false;
        this.agentCreateMemberModel = null;
        this.memberSearchResult = null;
    }

    public createMember(event: AgentCreateMemberPayload): void {
        event.companyID = this.selectedCompanyId;

        this.agentService.createMember(event).subscribe((response: AgentCreateMemberResponse) => {
            this.memberSearchResult = this.helperService.convertObjectIntoObject(event, new MemberSearchResult());
            this.memberSearchResult = this.helperService.convertObjectIntoObject(response, this.memberSearchResult);
            this.memberSearchResult.ssn = this.maskService.socialFormatInboundMask(event.ssnDecrypted);
            this.memberSearchResult.birthDate = this.maskService.shortDateFormat(event.dateOfBirth.toString());

            this.displayForm = false;
            this.displayConfirmForm = true;
        });
    }

    public back(): void {
        this.selectedCompanyId = null;
        this.reset();
    }
}